import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Field, inputClass } from './BackgroundFields';
import { uid } from '../utils/defaults';

export default function MenuExternalLinksFields({ links = [], sections = [], onChange }) {
  const list = links || [];

  const update = (next) => onChange(next);

  const addLink = () => {
    update([
      ...list,
      {
        id: uid('link'),
        label: 'Autre site',
        url: 'https://',
        openMode: 'external',
      },
    ]);
  };

  const patchLink = (id, patch) => {
    update(list.map((l) => (l.id === id ? { ...l, ...patch } : l)));
  };

  const removeLink = (id) => {
    update(list.filter((l) => l.id !== id));
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-2">
        <p className="text-xs font-semibold text-foreground">Onglets liens</p>
        <Button type="button" variant="outline" size="sm" onClick={addLink}>
          <Icon name="Plus" size={14} className="mr-1" />
          Ajouter
        </Button>
      </div>

      {list.length === 0 ? (
        <p className="text-xs text-muted-foreground">
          Liens externes, page publique ou ancre vers une section.
        </p>
      ) : (
        <ul className="space-y-3">
          {list.map((link) => {
            const openMode = link.openMode || 'external';
            const anchorValue = String(link.sectionAnchor || '').replace(/^#/, '');
            return (
              <li
                key={link.id}
                className="rounded-lg border border-border p-3 space-y-3 bg-muted/10"
              >
                <div className="flex items-start justify-between gap-2">
                  <span className="text-xs font-medium text-muted-foreground">Lien menu</span>
                  <button
                    type="button"
                    className="p-1 rounded hover:bg-destructive/10 text-destructive"
                    title="Supprimer"
                    onClick={() => removeLink(link.id)}
                  >
                    <Icon name="Trash2" size={14} />
                  </button>
                </div>
                <Field label="Libellé de l'onglet">
                  <input
                    className={inputClass}
                    value={link.label || ''}
                    onChange={(e) => patchLink(link.id, { label: e.target.value })}
                  />
                </Field>
                <Field label="Destination">
                  <select
                    className={inputClass}
                    value={openMode}
                    onChange={(e) => patchLink(link.id, { openMode: e.target.value })}
                  >
                    <option value="section">Ancre — section de la page</option>
                    <option value="external">Nouvel onglet (externe)</option>
                    <option value="iframe">Fenêtre intégrée (iframe)</option>
                    <option value="publicPath">Page publique (click &amp; collect…)</option>
                  </select>
                </Field>
                {openMode === 'section' ? (
                  <>
                    {sections.length > 0 ? (
                      <Field label="Section cible">
                        <select
                          className={inputClass}
                          value={anchorValue}
                          onChange={(e) =>
                            patchLink(link.id, { sectionAnchor: e.target.value })
                          }
                        >
                          <option value="">— Choisir une section —</option>
                          {sections.map((s) => (
                            <option key={s.id} value={s.anchor}>
                              {s.label} (#{s.anchor})
                            </option>
                          ))}
                        </select>
                      </Field>
                    ) : null}
                    <Field label="Ancre (identifiant)">
                      <input
                        className={inputClass}
                        value={link.sectionAnchor || ''}
                        onChange={(e) =>
                          patchLink(link.id, {
                            sectionAnchor: String(e.target.value || '').replace(/^#/, ''),
                          })
                        }
                        placeholder="accueil"
                      />
                    </Field>
                  </>
                ) : null}
                {openMode !== 'section' ? (
                  <Field
                    label={
                      openMode === 'publicPath' ? 'Chemin page publique' : 'URL du site'
                    }
                  >
                    <input
                      className={inputClass}
                      value={link.url || ''}
                      onChange={(e) => patchLink(link.id, { url: e.target.value })}
                      placeholder={
                        openMode === 'publicPath' ? '/commande' : 'https://…'
                      }
                    />
                  </Field>
                ) : null}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
